exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-history-log-display[data-v-7d5e1e1c]{overflow-wrap:break-word}.fts-history-log-value-text[data-v-7d5e1e1c]{white-space:pre-wrap}", ""]);

// exports
